import { Outlet } from 'react-router-dom'
import { Typography, useMediaQuery, Unstable_Grid2 as Grid } from '@mui/material'
import { ThemeProvider } from '@mui/material/styles'
import { useTheme } from '@mui/material/styles'
import { portfolioTheme } from '@/portfolioTheme'
import { PortfolioLine } from '@/components/portfolioLine/portfolioLine'
import { IntroSidebar } from '@/components/introSidebar/introSidebar'
import { Footer } from '@/components/footer/footer'
import CssBaseline from '@mui/material/CssBaseline'
import GlobalStyles from '@mui/material/GlobalStyles'
import StickyBox from 'react-sticky-box'

const Root = () => {
    const theme = useTheme()

    const mainGridSx = {
        mx: 3,

        [theme.breakpoints.down("sm")]: {
            ml: 1.3,
            mr: 0,
        },
    }

    return (
        <ThemeProvider theme={portfolioTheme}>
            <CssBaseline />
            <GlobalStyles
                styles={{
                    body: {
                        backgroundColor: '#1D1D1D',
                        color: '#ffffff',
                    },
                    ".footer-grid": {
                        position: "fixed",
                        bottom: 0,
                        left: 0,
                        right: 0,
                        width: '100%',
                    }

                }}
            />

            <Grid container sx={mainGridSx} spacing={3} justifyContent="space-between">
                <Grid xs={12} lg={12}>
                    <StickyBox offsetTop={2} offsetBottom={20}>
                        <IntroSidebar />
                    </StickyBox>
                </Grid>

                <Grid xs={12} lg={12}>
                    <PortfolioLine />
                </Grid>

                <Grid xs={12} lg={12} className="footer-grid">
                    <Footer />
                </Grid>
            </Grid>

            <Outlet />
        </ThemeProvider>
    )
}

export default Root;
